import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Card } from 'antd';
import { Formik } from 'formik';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { signInAdmin } from '../../redux/actions/admin';

class SignInAdmin extends React.PureComponent<any, any> {
  render() {
    return (
      <Card title="Sign in">
        <Formik
          initialValues={{ password: '' }}
          onSubmit={(values, actions) => {
            this.props.signInAdmin();
            actions.setSubmitting(false);
          }}
          render={(props: any): any => (
            <Form layout="vertical">
              <Form.Item>
                <Button type="primary" onClick={props.handleSubmit} color="primary">
                  Autenticarse como administrador con tu cuenta de Gmail
                </Button>
              </Form.Item>
            </Form>
          )}
        />
      </Card>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({ signInAdmin }, dispatch);
};

export default connect(
  null,
  mapDispatchToProps
)(SignInAdmin);
